// extracted by mini-css-extract-plugin
module.exports = {"discoverSort":"style_discoverSort__2-bMJ","text":"style_text__24qFC","select":"style_select__bEObe"};